/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdTreeSelectProps } from './type';

export const treeSelectDefaultProps: TdTreeSelectProps = {
  autoWidth: false,
  autofocus: false,
  borderless: false,
  clearable: false,
  data: [],
  filterable: false,
  loading: false,
  max: 0,
  minCollapsedNum: 0,
  multiple: false,
  placeholder: undefined,
  defaultPopupVisible: undefined,
  readonly: false,
  readOnly: false,
  reserveKeyword: true,
  size: 'medium',
  status: 'default',
  valueType: 'value',
};
